import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  notificationQR: {
    message: '',
    type: 'info',
    color: 'info',
  },
  open: false,
};

const NotificationQRSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setNotification(state, action) {
      state.notification = action.payload;
    },
    setToogleNotification(state, action) {
      state.open = action.payload;
    },
  },
});

export const { setNotification, setToogleNotification } =
  NotificationQRSlice.actions;

export default NotificationQRSlice.reducer;
